import React, { useEffect, useState } from "react";
import Loader from "../../components/loader";
import { getDataFromCmsApi } from "../../api/contentful-service";
import PropTypes from "prop-types";
import AwardsSection from "./awards-section";
import AchievementsSection from "./achievements-section";

AwardsContainer.propTypes = {
    pageId: PropTypes.string.isRequired,
    doesDisplayTitle: PropTypes.bool
};

function AwardsContainer({ pageId, doesDisplayTitle = true }) {
    const [data, setData] = useState([]);
    const [awards, setAwards] = useState([]);
    const [achievements, setAchievements] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        getData();
    }, []);

    const getData = async () => {
        const result = await getDataFromCmsApi(`webpage/${pageId}`);
        const awardsComponent = result?.components?.find((component) =>
            component?.name?.toLowerCase().includes("award")
        );
        const achievementsComponent = result?.components?.find((component) =>
            component?.name?.toLowerCase().includes("achievement")
        );

        setData(result);
        setAwards(awardsComponent?.items);
        setAchievements(achievementsComponent?.items);
        setIsLoading(false);
    };

    return isLoading ? (
        <Loader />
    ) : (
        data && (
            <>
                {doesDisplayTitle && (
                    <h1 className="display-5 text-center text-break pt-5 pb-4">{data.pageTitle}</h1>
                )}
                <div className="pb-5">
                    {awards && awards.length > 0 && <AwardsSection awardsPageData={data} awards={awards} />}
                    {achievements && achievements.length > 0 && (
                        <div className="py-5">
                            <AchievementsSection achievements={achievements} />
                        </div>
                    )}
                </div>
            </>
        )
    );
}

export default AwardsContainer;
